import { Statistic } from 'antd'
import { CSSProperties } from 'react'
import { formatDollars, formatDollarsAndCents, formatPercentage } from './budgetCalculatorModel'

type StatisticStyle = 'dollars' | 'dollarsAndCents' | 'percentage' | 'default'
type Props = {
  statisticStyle?: StatisticStyle
  title: string
  value: number
  negativeColor?: string
  positiveColor?: string
}

const formatValue = (value: number, style: StatisticStyle): string => {
  switch (style) {
    case 'dollars': return formatDollars(value)
    case 'dollarsAndCents': return formatDollarsAndCents(value)
    case 'percentage': return formatPercentage(value)
    default: return value.toLocaleString()
  }
}

const getStyle = (value: number, negativeColor?: string, positiveColor?: string): CSSProperties => {
  if (value < 0 && negativeColor) {
    return { color: negativeColor }
  }
  if (value > 0 && positiveColor) {
    return { color: positiveColor }
  }
  return {}
}

const BudgetStatistic = ({ statisticStyle: style = "default", title, value, negativeColor, positiveColor }: Props) => {
  return <Statistic title={title} value={formatValue(value, style)} valueStyle={getStyle(value, negativeColor, positiveColor)} />
}

type AmountWithPercentageProps = {
  title: string
  amount: number
  percentage: number
  negativeColor?: string
  positiveColor?: string
}
const AmountWithPercentage = ({ title, amount, percentage, negativeColor, positiveColor }: AmountWithPercentageProps) => {
  return <Statistic
    title={title}
    value={formatValue(amount, 'dollars')}
    valueStyle={getStyle(amount, negativeColor, positiveColor)}
    suffix={<small>({formatValue(percentage, 'percentage')})</small>}
  />
}

BudgetStatistic.AmountWithPercentage = AmountWithPercentage;

export default BudgetStatistic
